import axios from 'axios';
import { showError } from './utils';
import { ENV } from '../../config/env';
import { authHeader } from './auth-header';

export const API = axios.create({
  baseURL: ENV.API_BASE_URL,
});

API.interceptors.request.use(
  (config) => {
    const headers = authHeader();
    if (config.headers && typeof (config.headers as any).set === 'function') {
      // AxiosHeaders 实例
      if (headers.Authorization) {
        (config.headers as any).set('Authorization', headers.Authorization);
      }
    } else if (config.headers) {
      // 普通对象
      if (headers.Authorization) {
        (config.headers as any)['Authorization'] = headers.Authorization;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

API.interceptors.response.use(
  (response) => response,
  (error) => {
    showError(error);
    return Promise.reject(error); // 关键
  },
);

